import { NavLink } from "react-router"

import ProgressBar from "./ProgressBar"

function ts_to_str(ts) {
    const date = new Date(ts * 1000)
    const dateString = String(date.getDate()).padStart(2, '0')
      + "." + String(date.getMonth() + 1).padStart(2, '0') + "." + date.getFullYear()
    const timeString = String(date.getHours()).padStart(2, '0') + ":" + String(date.getMinutes()).padStart(2, '0')
    return `${dateString} ${timeString}`
}

export default function NewsList({ news, ignore }) {
  const newsList = news.map(item => {
    if (ignore === item.object_path) {
      return ""
    }

    const tsStr = `Cập nhật: ${ts_to_str(item.updated)}`
    return (
      <tr key={item.object_path}>
        <td>
          <NavLink to={"/article/" + item.object_path}>
            {item.title}&nbsp;
            <span className="has-text-weight-light has-text-grey-light is-italic">({tsStr})</span>
          </NavLink>
        </td>
      </tr>
    )
  })

  return (
    <>
    <h1 className="title">Tin mới nhất</h1>
    {
      news.length < 1 ? <ProgressBar /> : 
      <table className="table is-striped is-hoverable is-fullwidth">
        <tbody>
          {newsList}
        </tbody>
      </table>
    }
    </>
  )
}
